<div class="card">
	<div class="card-header">
		<h1>Eliminar Facturas Duplicadas De Venta</h1>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col form-group">
				<label for="company" class="form-label font-weight-bold">Empresa:</label>
				<div class="input-group">
					<app-input-autocomplete (changeStatus)="selectCompany($event.filterElement)"
						(inputMethod)="searchCompany()" [allBorderRadius]="true" [filterElements]="companies"
						[placeholder]="'Busca una empresa'" [custom]="true" [inputs]="inputs">
						<ng-template #itemsTemplate let-filter>
							<!-- This is the content that will be projected -->
							<div items>
								<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
									{{filter.companyName?filter.companyName:filter.name}}</h5>
								<span class="text-muted" style="color: white !important;">{{filter.alphanumericId}} -
									NIT: <b>{{filter.companyNIT?filter.companyNIT:filter.nit}}</b></span>
							</div>
						</ng-template>
					</app-input-autocomplete>
				</div>
			</div>
		</div>
        <div class="row">
            <div class="col form-group">
                <label for="startDate" class="form-label">Fecha Inicial</label>
                <input 
                    type="date" 
                    id="startDate" 
                    name="startDate" 
                    [(ngModel)]="startDate" 
                    class="form-control">
            </div>
            <div class="col form-group">
                <label for="endDate" class="form-label">Fecha Final</label>
                <input 
                    type="date" 
                    id="endDate" 
                    name="endDate" 
                    [(ngModel)]="endDate" 
                    class="form-control">
            </div>
        </div>
	</div>
    <div>
        <app-loading-button [object]="upload" [disabled]="!selected" (clicked)="deleteInvoices()"></app-loading-button>
    </div>
</div>